import { css } from 'emotion'

export const textSmallStyles = css`
  font-size: 0.9em;
`
